module.exports = __webpack_public_path__ + "static/media/victor.15fadca2.png";